import { createAction } from '@reduxjs/toolkit';

export const MENU_COLLAPSE = 'MENU_COLLAPSE';

export const menuCollapse = createAction<boolean>(MENU_COLLAPSE);
